/*
 *  To set up a new customer action, go to https://ads.google.com, sign in, then go to
 *  Goals > Summary > Create conversion action > Website > Scan > Add a conversion action manually
 *
 *  Read more on how to add custom parameters to the event here: https://support.google.com/google-ads/answer/7544718?hl=en
 */
import { __decorate } from "tslib";
import { _Memo } from '@naturalcycles/js-lib';
import { googleTag } from './googleTag.pixel.js';
class GoogleAdsClient {
    pixelId = 'AW-995227532';
    load() {
        googleTag(this.pixelId);
    }
    // Find this event in google ads dashboard here: Goals > Summary > Page view > Page view
    pageView({ id }) {
        this.load();
        window.gtag('event', 'conversion', {
            send_to: this.pixelId + ConversionId.PageView,
            transaction_id: id,
        });
    }
    // Find this event in google ads dashboard here: Goals > Summary > Sign-up > Submit lead form
    lead({ id }) {
        this.load();
        window.gtag('event', 'conversion', {
            send_to: this.pixelId + ConversionId.Lead,
            transaction_id: id,
        });
    }
    // Find this event in google ads dashboard here: Goals > Summary > Add to cart > Select plan
    addToCart({ id, amount, currency, plan }) {
        this.load();
        window.gtag('event', 'conversion', {
            send_to: this.pixelId + ConversionId.AddToCart,
            transaction_id: id,
            amount,
            currency,
            plan,
        });
    }
    // Find this event in google ads dashboard here: Goals > Summary > Purchase > NPU
    purchase({ id, amount, currency, plan }) {
        this.load();
        window.gtag('event', 'conversion', {
            send_to: this.pixelId + ConversionId.Purchase,
            transaction_id: id,
            amount,
            currency,
            plan,
        });
    }
}
__decorate([
    _Memo()
], GoogleAdsClient.prototype, "load", null);
export const googleAdsClient = new GoogleAdsClient();
// Info on finding conversion IDs https://support.google.com/tagmanager/answer/6105160?hl=en
var ConversionId;
(function (ConversionId) {
    ConversionId["PageView"] = "/sfgACLLW9OYCEIzvx9oD";
    ConversionId["Lead"] = "/oWp6CKn38OkCEIzvx9oD";
    ConversionId["AddToCart"] = "/Cj3qCNex84YaEIzvx9oD";
    ConversionId["Purchase"] = "/aJAOCL_E3HcQjO_H2gM";
})(ConversionId || (ConversionId = {}));
